import { render, staticRenderFns } from "./instant.vue?vue&type=template&id=01c0f153&"
import script from "./instant.vue?vue&type=script&lang=js&"
export * from "./instant.vue?vue&type=script&lang=js&"
import style0 from "./instant.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports